import React, { useContext, useState, useEffect } from "react";
import { Dialog, List, SwipeAction, Toast } from "antd-mobile";
import { Spin } from "antd";

import { Col, Form, Row, Card } from "react-bootstrap";
import { Button } from "react-bootstrap";
import axios from "axios";
import PsContext from "../../context";
import {
  MOB_ICONS,
  momentDate,
  upperCase,
  S3_BUCKET_HOME_PATH,
  siteUrl,
  ParseFloat,
  groupByMultiple,
  semesterValue,
} from "../../utils";
import Header from "../header";
import WelcomeProfile from "../home/welcomeProfile";
import ModuleAccess from "../../context/moduleAccess";
import { ServiceUrl } from "../../utils/serviceUrl";
import toast from "react-hot-toast";
import { APP_TYPE, baseUrl } from "../../utils";
import PrintPdf from "./printpdf";
import PsModalWindow from "../../utils/PsModalWindow";
import { FileOutline } from "antd-mobile-icons";

const DirectHallTicket = (props) => {
  const context = useContext(PsContext);
  const [viewData, setViewData] = useState([]);
  const [loader, setLoader] = useState([]);
  const [captcha, setCaptcha] = useState([]);
  const [isDownload, setIsDownload] = useState(false);
  useEffect(() => {
    loadData();
    loadCaptcha();
  }, []);

  const loadData = () => {
    setLoader(true);
    const form = new FormData();
    axios
      .post(
        ServiceUrl.STUDENTS.LIST_HALLTICKET +
          "?" +
          "&student_uuid=" +
          context.user.uuid +
          "&registerno=" +
          context.user.registerno // Add registerno parameter
      )
      .then((res) => {
        if (res.data.status === "1") {
          setViewData(res.data.data);
          console.log("te", res.data.data);
        } else {
          Toast.show({ content: res.data.message || "Error" });
        }
        setLoader(false);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setLoader(false);
      });
  };
  const loadCaptcha = () => {
    setLoader(true);
    axios.get("v1/captcha").then((res) => {
      if (res["data"].status == "1") {
        setCaptcha(res["data"]);
      }
      setLoader(false);
    });
  };
  const downloadFile = (hallticket_exam_id) => {
    setLoader(true);
    // let registrationNumber = viewData[0].registerno;
    let registrationNumber = context.user.uuid;
    let link = `${baseUrl}mob/v1/pdf?q=${registrationNumber}&hallticket_exam_id=${hallticket_exam_id}`;
    var a = document.createElement("a");
    a.setAttribute("download", registrationNumber);
    a.setAttribute("href", link);
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    setLoader(false);
    setIsDownload(false)
    Toast.show({
      content: "Download Started, file will be downloaded",
      position: "top",
    });
  };
  const handleCaptcha = (e) => {
    //console.log('test', e.target.value, captcha.text)

    if (e.target.value.length == 5) {
      var form = new FormData();
      form.append("encrypted_text", captcha.code);
      form.append("value", e.target.value);
      axios.post("mob/stu/v1/hallticket/validate-captcha", form).then((res) => {
        if (res["data"].status == "1") {
          if (res["data"].data) setIsDownload(true);
          // console.log(res["data"].data)
        }
        setLoader(false);
      });
    }
  };
  return (
    <>
      <Header title="Hall Ticket" backAction={true} />
      <div className="page-content-wrapper">
        <div className="container py-2 px-0">
          <WelcomeProfile />
          <div className="bg-blue-100 text-primary fw-bold p-2 form-title-card">
            <input
              type="hidden"
              name="registerno"
              value={context.user.registerno}
            />

            {viewData.length > 0 ? (
              viewData.map((item, index) => (
                <>
                  <Row className="mt-3" key={index}>
                    <Col md={4}>DOWNLOAD E-HALL TICKET</Col>

                    <Col md={4}>{item.exam_title.toUpperCase()}</Col>
                  </Row>
                  <Row
                    className="mt-3"
                    key={index}
                    style={{ textAlign: "center" }}
                  >
                    {!item.last_status || item.last_status == "approved" ? (
                      <>
                        {!isDownload && (
                          <>
                            <Col md={2} sm={2}>
                              <img
                                src={captcha.img}
                                className="border me-2"
                                style={{ width: "100px" }}
                              />

                              <a onClick={(e) => loadCaptcha()}>
                                <i className="fa-solid fa-arrows-rotate"></i>
                              </a>
                            </Col>

                            <Col md={2} sm={2}>
                              <Form.Control
                                type="text"
                                name="captcha"
                                placeholder="Enter Captcha"
                                className="fw-bold"
                                required
                                style={{ width: "150px" }}
                                onChange={(e) => handleCaptcha(e)}
                              />
                              <Form.Control.Feedback type="invalid">
                                Enter Captcha to Download
                              </Form.Control.Feedback>
                            </Col>
                          </>
                        )}

                        <Col md={4}>
                          {isDownload && !loader && (
                            <li className="list-inline-item">
                              <Button
                                size="md"
                                variant="primary"
                                className="border-start fs-6"
                                style={{ marginLeft: "320%" }}
                                onClick={(e) =>
                                  downloadFile(item.hallticket_exam_id)
                                }
                              >
                                <i className="fa-solid fa-file-arrow-down"></i>
                              </Button>
                            </li>
                          )}
                        </Col>
                      </>
                    ) : (
                      <>
                        Hall Ticket Blocked/Server Busy ,<br></br>
                      </>
                    )}
                  </Row>
                </>
              ))
            ) : (
              <Row className="mt-3">
                <Col md={12}>No Hall Ticket Data Found</Col>
              </Row>
            )}
          </div>
        
        </div>
      </div>
    </>
  );
};
export default DirectHallTicket;
